import { colorConstants } from 'config/colorConstants';

type Settings04IconProps = {
    color?: string;
};

const Settings04Icon = ({ color = colorConstants.tableHeaderIcon }: Settings04IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.5" height="10" viewBox="0 0 12.5 10" fill="none" aria-hidden="true">
        <path
            d="M2.5 5C3.6649 5 4.64374 5.79673 4.92126 6.875H11.875C12.2202 6.875 12.5 7.15482 12.5 7.5C12.5 7.84518 12.2202 8.125 11.875 8.125H4.92126C4.64374 9.20327 3.6649 10 2.5 10C1.11929 10 0 8.88071 0 7.5C0 6.11929 1.11929 5 2.5 5ZM11.25 2.5C11.25 1.80964 10.6904 1.25 10 1.25C9.30964 1.25 8.75 1.80964 8.75 2.5C8.75 3.19036 9.30964 3.75 10 3.75C10.6904 3.75 11.25 3.19036 11.25 2.5ZM1.25 7.5C1.25 8.19036 1.80964 8.75 2.5 8.75C3.19036 8.75 3.75 8.19036 3.75 7.5C3.75 6.80964 3.19036 6.25 2.5 6.25C1.80964 6.25 1.25 6.80964 1.25 7.5ZM12.5 2.5C12.5 3.88071 11.3807 5 10 5C8.8351 5 7.85626 4.20327 7.57874 3.125H0.625C0.279822 3.125 0 2.84518 0 2.5C3.72529e-08 2.15482 0.279822 1.875 0.625 1.875H7.57874C7.85626 0.79673 8.8351 0 10 0C11.3807 0 12.5 1.11929 12.5 2.5Z"
            fill={color}
        />
    </svg>
);

export default Settings04Icon;
